import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { VxIconButtonComponent } from '@ui/icon-button/icon-button.component';
import { ClipboardService } from 'src/app/services/clipboard/clipboard.service';

/** Wide enough to read as a key without leaking its length. */
const MASK = '•'.repeat(32);

/**
 * A read-only value with a copy button: the organization id, or a freshly
 * created API key. A `secret` value starts masked and gets a reveal toggle.
 */
@Component({
  selector: 'app-copy-value',
  templateUrl: './copy-value.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [VxIconButtonComponent],
  host: { class: 'block' },
})
export class CopyValueComponent {
  readonly value = input.required<string>();

  /** Already-translated accessible name for the copy button. */
  readonly copyLabel = input.required<string>();

  readonly secret = input(false);

  /** Accessible names for the reveal toggle; required when `secret` is set. */
  readonly revealLabel = input<string>();

  readonly hideLabel = input<string>();

  private clipboard = inject(ClipboardService);

  protected revealed = signal(false);

  protected masked = computed(() => this.secret() && !this.revealed());

  protected displayValue = computed(() =>
    this.masked() ? MASK : this.value()
  );

  protected toggleLabel = computed(() =>
    this.revealed() ? this.hideLabel() : this.revealLabel()
  );

  protected toggleReveal() {
    this.revealed.update(revealed => !revealed);
  }

  protected copy() {
    this.clipboard.copy(this.value());
  }
}
